export const UR_WORDS_LIST = []
